import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonSetting, OfflineSurvey } from '../../common-class/survey';
import { ParticipationDataService } from '../../_services/participation-data.service';
import { SurveySpecificData } from '../../common-class/survey-specific-data';
import { ParticipationResponseData } from 'src/app/common-class/response-data';
import { EncryptionAndDecryption } from 'src/app/COMMON-LOGIC/EncryptionAndDecryption';
import { SurveyData } from 'src/app/common-class/survey-data';
import { SurveyProperties, SurveySearchModel } from 'src/app/common-class/survey-properties';
import { CustomErrorsHandlerService } from 'src/app/_services/custom-errors-handler.service';
import { OfflineModel } from 'src/app/common-class/OfflineModel';
import { CommonLogic } from 'src/app/COMMON-LOGIC/common-logic';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-offline',
  templateUrl: './offline.component.html',
  styleUrls: ['./offline.component.css'],
})
export class OfflineComponent implements OnInit {
  @Output() Startsurvey1 = new EventEmitter();
  @Output() SurveyResponseUpdate = new EventEmitter();
  @Output() GetData = new EventEmitter();
  surveyData: SurveyData;
  surveySpecificData: SurveySpecificData;
  offLineSurveyProperties: SurveyProperties;
  surveyProperties: SurveyProperties;
  surveySearchModel: SurveySearchModel;
  offlineModel: OfflineModel;
  public OfflineResponseData: any = [];
  public SurveyData: any = [];
  isPreview: boolean = false;
  selectedLang: number;
  urlParam: string;
  ResponseCount: number;
  ResponseRecorded: number = 0;
  blnShowGotiT: boolean = true;
  isMobile: boolean = false;
  isTablet: boolean = false;
  isDeviceCSS: string = '';
  UploadPerc: number;
  processCount: number = 1;
  prendingResponse: number = 0;
  completeResponse: number = 0;
  incompleteResponse: number = 0;
  offlineID: number = 0;
  isOfflineEnable: boolean = true;
  surveyTitle: string = '';
  corp_mailid: string;
  isSomthingWrong: boolean = false;
  isCancelUpload: boolean = false;
  commonLogic: CommonLogic;
  showLoader = false;
  isK12 = false;
  productName = '';
  productTitle = '';
  surveyKey: string;

  constructor(
    @Inject(LOCAL_STORAGE) private storage: StorageService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private commonSetting: CommonSetting,
    public service: ParticipationDataService,
    private offlineSurvey: OfflineSurvey,
    private errorsHandlerService: CustomErrorsHandlerService  ) {
    this.commonLogic = new CommonLogic();
  }

  /**
   * this method use for generating URL.
   * @param isLoading
   * @returns
   */
  PrepareUrlData(strQueryString: string, isLoading: boolean): any {
    let map = new Map<string, string>();
    strQueryString = strQueryString.substring(1);
    let arrQ = strQueryString.split('&');
    for (const q of arrQ) {
      const split = q.split('=');
      map.set(split[0].trim(), split[1].trim());
    }

    let lang =
      map.get('lang') == '' || map.get('lang') == undefined ? 0 : parseInt(map.get('lang'));
    this.surveySearchModel.isGoBackQuota =
      map.get('isGoBackQuota') == '' || map.get('isGoBackQuota') == undefined ? false : true;
    this.surveySearchModel.isEmbedMobile =
      map.get('isEmbedMobile') == '' || map.get('isEmbedMobile') == undefined ? false : true;
    this.surveySearchModel.isPartial =
      map.get('isPartial') == '' || map.get('isPartial') == undefined ? false : true;
    this.surveySearchModel.isReopen =
      map.get('isReopen') == '' || map.get('isReopen') == undefined ? false : true;

    if (lang == undefined) {
      lang = map.get('lang') == '' || map.get('lang') == undefined ? 0 : parseInt(map.get('lang'));
    } else {
      this.surveySearchModel.lang = lang;
    }

    this.surveySearchModel.status =
      map.get('status') != undefined ||
      map.get('status') != null ||
      map.get('Status') != undefined ||
      map.get('Status') != null
        ? 'preview'
        : '';

    if (this.surveySearchModel.status == 'preview') {
      this.isPreview = true;
      this.surveySearchModel.isThankYou =
        map.get('isThankYou') == '' || map.get('isThankYou') == undefined ? false : true;
      this.surveySearchModel.type =
        map.get('type') == '' || map.get('type') == undefined ? '' : map.get('type');
      this.surveySearchModel.msgId =
        map.get('msgId') == '' || map.get('msgId') == undefined ? 0 : parseInt(map.get('msgId'));
      this.surveySearchModel.viewPort =
        map.get('viewport') == '' || map.get('viewport') == undefined ? '' : map.get('viewport');
      if (
        document.querySelector('#hdnCurrentLang') &&
        (document.querySelector('#hdnCurrentLang') as HTMLInputElement).value !== '-1' &&
        (document.querySelector('#hdnCurrentLang') as HTMLInputElement).value
      ) {
        lang = parseInt((document.querySelector('#hdnCurrentLang') as HTMLInputElement).value);
      }
    }

    if (!isLoading) {
      if (this.selectedLang != undefined && this.selectedLang != null) {
        if (this.selectedLang != this.surveyData.SurveySettings.primary_lang_id) {
          lang = this.selectedLang;
        }
      }
      
    }
    if (isLoading) {
      this.surveySearchModel.responseID =
        map.get('Uid') == '' || map.get('Uid') == undefined ? '' : map.get('Uid');
      this.surveySearchModel.Dir =
        map.get('Dir') == '' || map.get('Dir') == undefined ? '' : map.get('Dir');
    }
    this.surveySearchModel.langPop =
      map.get('langPop') == '' || map.get('langPop') == undefined ? false : true;
    this.selectedLang = lang;

    return this.urlParam;
  }
  /**
   * this method used for resolution of screen.
   * @returns
   */
  getResolution(): string {
    return screen.width + 'x' + screen.height + ' ,color depth=' + screen.colorDepth + ' bit';
  }

  ngOnInit() {
    this.productTitle = environment.productName;
    if (this.productTitle == 'K12 Insight') {
      this.isK12 = true;
      this.productName = 'k12';
    }
    let k = '';
    let lang = '';
    this.surveySearchModel = new SurveySearchModel();
    this.offlineSurvey = new OfflineSurvey();
    this.isOfflineEnable = true;
    this.activatedRoute.queryParams.subscribe(async (params) => {
      k = params['k'];
      lang = params['lang'] == '' || params['lang'] == undefined ? '0' : params['lang'];
    });
    if (navigator.onLine) {
      this.showLoader = true;
      this.service.GetData('GetOffLineData?k=' + k).subscribe(
        async (data) => {
          let arrData = EncryptionAndDecryption.DecryptionData(
            '123456$#@$^@1ERF',
            await data.result,
          );
           arrData = JSON.parse(arrData);
          this.offLineSurveyProperties = await arrData.SurveyProperties;
          this.commonSetting = await this.offLineSurveyProperties.commonSetting;
          this.offlineModel = await this.offLineSurveyProperties.offlineModel;
          this.surveyTitle = this.offlineModel.surveyTitle;
          this.isOfflineEnable = this.offlineModel.isOfflineEnable;
          this.offlineID = this.offlineModel.OfflineURLID;
          this.corp_mailid = this.offlineModel.corp_mailid;
          this.offlineSurvey.OfflineURLID = this.offlineModel.OfflineURLID;
          this.offlineSurvey.Surveytimeout = this.offlineModel.Surveytimeout;
          this.offlineSurvey.Thankyoumessagetimeout = this.offlineModel.Thankyoumessagetimeout;
          this.offlineSurvey.corp_mailid = this.offlineModel.corp_mailid;
          this.offlineSurvey.isOfflineEnable = this.offlineModel.isOfflineEnable;
          this.offlineSurvey.primaryLang = this.offlineModel.primaryLang.toString();
          this.offlineSurvey.surveyTitle = this.offlineModel.surveyTitle;
          this.offlineSurvey.surveyno = this.offlineModel.surveyno.toString();
          this.offlineSurvey.isOfflineSurvey = this.offlineModel.isOfflineSurvey;
          this.commonLogic.surveyScriptGenerator(this.offLineSurveyProperties.strSurveyJS);
          this.service.setOfflineSurvey(this.offlineSurvey);
          localStorage.removeItem('OfflineSurveyKey');
          if (this.offlineModel.LanguageDatas.length > 0) {
            await this.processLanguagesSequentially(this.offlineModel.LanguageDatas, lang);
          }
          this.showLoader = false;
        },
        (error) => {
          this.showLoader = false;
          this.errorsHandlerService.handleError(error);
          if (error.name == 'HttpErrorResponse') {
            window.location.replace('../survey/sd?err=1&ng=1&cn=' + 101);
          }
        },
      );
    }
    let encryptedData = this.storage.get('ResponseData_' + k) || [];
    if (encryptedData.length > 0) {
      encryptedData = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', encryptedData);
      this.OfflineResponseData = JSON.parse(encryptedData);
    }

    this.storage.set('Editresponse_' + k, []);

    this.incompleteResponse = this.OfflineResponseData.filter(
      (e) => e.ResponseCommanData.ResponseStatus == 'INCOMPLETE',
    ).length;
    this.completeResponse = this.OfflineResponseData.filter(
      (e) => e.ResponseCommanData.ResponseStatus == 'COMPLETE',
    ).length;

    if (this.completeResponse > 0 || this.incompleteResponse == 0) {
      this.OfflineResponseData = this.OfflineResponseData.filter(
        (e) => e.ResponseCommanData.ResponseStatus == 'COMPLETE',
      );
    } else {
      this.OfflineResponseData = this.OfflineResponseData.filter(
        (e) => e.ResponseCommanData.ResponseStatus == 'INCOMPLETE',
      );
    }
    this.blnShowGotiT =
      this.storage.get('GotIT_' + k) != undefined ? this.storage.get('GotIT_' + k) : true;
    this.ResponseRecorded =
      this.storage.get('ResponseRecorded_' + k) != undefined
        ? this.storage.get('ResponseRecorded_' + k)
        : 0;
    this.ResponseCount = this.storage.get('ResponseCount_' + k) || 0;
    if (this.ResponseCount == 0) {
      this.storage.set('ResponseCount_' + k, 0);
    }

    if (this.commonSetting != undefined) {
      const body = document.body;
      this.isMobile = this.commonSetting.isMobileDevice;
      this.isTablet = this.commonSetting.isTablet;
      if (this.isTablet) {
        if (
          navigator.maxTouchPoints > 1 ||
          navigator.userAgent.toLowerCase().indexOf('firefox') > -1 ||
          navigator.userAgent.toLowerCase().indexOf('ipad') > -1
        ) {
          this.isTablet = true;
        } else {
          this.isTablet = false;
        }
      }
      this.service.setMobile(this.isMobile);
      if (this.isMobile) {
        body.classList.add('mobile-wrapper');
        if (this.isPreview && document.querySelector('#previewViewport') === null) {
          body.classList.add('mobile-scroll');
        } else if (!this.isPreview && !this.commonSetting.isEmbedMobile) {
          body.classList.add('mobile-scroll');
        }
      } else if (this.isTablet) {
        body.classList.add('tablet-wrapper');
        if (document.querySelector('#previewViewport') === null) {
          body.classList.add('mobile-scroll');
        } else if (navigator.maxTouchPoints > 1) {
          body.classList.add('mobile-scroll');
        }
      }
    }
  }

  ngAfterViewInit() {
    if (this.completeResponse > 0 || this.incompleteResponse == 0) {
      document.querySelector('.Incompleted')?.classList.remove('active');
      document.querySelector('.Completed')?.classList.add('active');
    } else {
      document.querySelector('.Completed')?.classList.remove('active');
      document.querySelector('.Incompleted')?.classList.add('active');
    }
    
    if (this.isMobile) {
      setTimeout(() => {
        this.adjustMobileLayout();
      }, 100);
    }

    window.addEventListener('scroll', () => {
      if (document.querySelector('.mobile-wrapper') === null && document.querySelector('.r-numbers-cont') !== null) {
        this.scrollResponse();
      }
    });
  }

  sendEmail() {
    window.location.href = 'mailto:' + this.corp_mailid;
  }

  Startsurvey() {
    //response limit handle
    if (this.OfflineResponseData.length < 100) {
      let path = 'form?' + this.GetUrlData(false, 0);
      this.router.navigateByUrl(path);
    } else {
      alert('Response Limit reached please upload pending responses and try again');
      let path = 'offline?' + this.GetUrlData(false, 0);
      this.router.navigateByUrl(path);
    }
  }

  CheckOfflineUrl(): boolean {
    let off_url = "GetOfflineModeData?k=" + this.surveyKey + "&offlineID=" + this.offlineID;
    this.service.GetOfflineModeData(off_url).subscribe(
      async (data) => {
        this.isOfflineEnable = await data;
        if (!this.isOfflineEnable) {
          return false;
        }
      },
      () => {},
    );
    return true;
  }

  CancelUpload() {
    this.isCancelUpload = true;
    const loadingWrapper = document.querySelector('.loading-wrapper') as HTMLElement;
    if (loadingWrapper) {
      loadingWrapper.style.display = 'none';
    }
  }

  RetryResponses() {
    this.isSomthingWrong = false;
    this.UploadResponses();
  }

  CloseSomthingWrong() {
    this.isSomthingWrong = false;
    const loadingWrapper = document.querySelector('.loading-wrapper') as HTMLElement;
    if (loadingWrapper) {
      loadingWrapper.style.display = 'none';
    }
  }

  UploadResponses(isResursiveCall: boolean = false) {
    if (navigator.onLine) {
      if (this.isOfflineEnable) {
        let k = '';
        const loadingWrapper = document.querySelector('.loading-wrapper') as HTMLElement;
        if (loadingWrapper) {
          loadingWrapper.style.display = '';
        }
        this.activatedRoute.queryParams.subscribe(async (params) => {
          k = params['k'];
        });
        let SkipLogicHiddenQIdsAll: string = null;
        let encryptedData = this.storage.get('ResponseData_' + k) || [];

        if (encryptedData.length > 0) {
          encryptedData = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', encryptedData);
          this.OfflineResponseData = JSON.parse(encryptedData);
        }

        if (!isResursiveCall) {
          this.prendingResponse = this.OfflineResponseData.length;
          this.processCount = this.prendingResponse == 1 ? 1 : 0;
          this.isCancelUpload = false;
        }

        if (this.OfflineResponseData.length > 0) {
          this.surveySearchModel.key = k;
          this.surveySearchModel.Dir = 'NXT';
          this.surveySearchModel.intelMatrix = SkipLogicHiddenQIdsAll;
          this.surveySearchModel.isGoBackQuota = false;
          this.surveySearchModel.isEmbedMobile = false;
          this.surveySearchModel.isPartial = false;
          this.surveySearchModel.isReopen = false;
          this.surveySearchModel.status = '';

          this.surveySearchModel.isAssessmentSubmit = false;

          this.surveySearchModel.pageNo = 999;
          let url = "OfflineResponseData?k=" + this.surveyKey;
          if (!this.isSomthingWrong && !this.isCancelUpload) {


            if (this.OfflineResponseData[0].ResponseCommanData.ResponseStatus == 'INCOMPLETE') {
              this.surveySearchModel.lang =
                this.OfflineResponseData[0].ResponseCommanData.ResponseLangID;
              this.surveySearchModel.Dir = 'SAV';
            } else {
              this.surveySearchModel.lang =
                this.OfflineResponseData[0].ResponseCommanData.ResponseLangID;
              this.surveySearchModel.Dir = 'NXT';
            }

            let data =
              this.storage.get(
                'SurveyData_' +
                  k +
                  '_' +
                  this.OfflineResponseData[0].ResponseCommanData.ResponseLangID,
              ) || [];
            let arrData = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', data);
            this.SurveyData = JSON.parse(arrData);

            let data1 =
              this.storage.get(
                'SurveyProperties_' +
                  k +
                  '_' +
                  this.OfflineResponseData[0].ResponseCommanData.ResponseLangID,
              ) || [];
            let arrData1 = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', data1);
            this.surveyProperties = JSON.parse(arrData1);
            this.surveyProperties.responseInfo = this.OfflineResponseData[0].responseInfo;

            this.surveyProperties.ParticipationResponseData = JSON.parse(
              JSON.stringify(this.OfflineResponseData[0]),
            );
            this.surveySearchModel.surveyProperties = this.surveyProperties;

            this.surveySpecificData = new SurveySpecificData();
            this.service
              .postDataUsingPromise(
                url,
                JSON.stringify(
                  EncryptionAndDecryption.EncryptionData(
                    '123456$#@$^@1ERF',
                    JSON.stringify(this.surveySearchModel),
                  ),
                ),
              )
              .then(
                async (data) => {
                  let arrData = EncryptionAndDecryption.DecryptionData(
                    '123456$#@$^@1ERF',
                    await data,
                  );
                  this.surveySpecificData.ParticipationMessages = JSON.parse(arrData);

                  if (this.surveySpecificData.ParticipationMessages != undefined) {
                    if (
                      this.surveySpecificData.ParticipationMessages.OfflineMessage == 'succeces'
                    ) {
                      this.ResponseRecorded = this.ResponseRecorded + 1;
                      this.storage.set('ResponseRecorded_' + k, this.ResponseRecorded);
                      if (this.prendingResponse != 1) {
                        this.processCount = this.processCount + 1;
                      }
                      let val = (this.processCount / this.prendingResponse) * 100;
                      if (val < 1) {
                        this.UploadPerc = 1;
                      } else {
                        this.UploadPerc = Math.floor(val);
                      }

                      let ind = this.OfflineResponseData.indexOf(this.OfflineResponseData[0]);
                      this.OfflineResponseData.splice(ind, 1);
                      this.incompleteResponse = this.OfflineResponseData.filter(
                        (a) => a.ResponseCommanData.ResponseStatus == 'INCOMPLETE',
                      ).length;
                      this.completeResponse = this.OfflineResponseData.filter(
                        (a) => a.ResponseCommanData.ResponseStatus == 'COMPLETE',
                      ).length;
                      this.storage.set(
                        'ResponseData_' + k,
                        EncryptionAndDecryption.EncryptionData(
                          '123456$#@$^@1ERF',
                          JSON.stringify(this.OfflineResponseData),
                        ),
                      );

                      const loadingFiller = document.querySelector('.loading-filler') as HTMLElement;
                      if (loadingFiller) {
                        loadingFiller.style.width = `${this.UploadPerc}%`;
                      }

                      if (this.UploadPerc == 100) {
                        setTimeout(() => {
                          loadingWrapper.style.display = 'none';
                          this.showAlert(document.querySelector('.Plat_Alert') as HTMLElement);
                        }, 1000);
                      }
                    }

                    if (this.OfflineResponseData.length > 0) {
                      this.UploadResponses(true);
                    }
                  }
                },
                () => {
                  this.isSomthingWrong = true;
                },
              );
          } else {
            setTimeout(() => {
              loadingWrapper.style.display = 'none';
            }, 100);
          }
        }
      }
    } else {
      alert('No Internet');
      setTimeout(() => {
        const loadingWrapper = document.querySelector('.loading-wrapper') as HTMLElement;
        if (loadingWrapper) {
          loadingWrapper.style.display = 'none';
        }
      }, 100);
    }
  }

  showAlert(obj: HTMLElement) {
    obj.classList.add('active');
  }

  Edit(response: ParticipationResponseData) {
    let k = '';
    let lang1 = '';
    this.activatedRoute.queryParams.subscribe(async (params) => {
      k = params['k'];
      lang1 = response.ResponseCommanData.ResponseLangID.toString(); 
    });
    let data =
      this.storage.get('SurveyData_' + k + '_' + response.ResponseCommanData.ResponseLangID) || [];
    let arrData = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', data);
    this.SurveyData = JSON.parse(arrData);
    this.SurveyData.SurveySpecificData.ParticipationResponseData = response;
    this.SurveyData.SurveyData.ResponseInfo.ResponseUID = response.ResponseCommanData.ResponseUID;
    data = EncryptionAndDecryption.EncryptionData(
      '123456$#@$^@1ERF',
      JSON.stringify(this.SurveyData),
    );
    this.storage.set('SurveyData1_' + k + '_' + lang1, data);
    this.storage.set(
      'Editresponse_' + k,
      EncryptionAndDecryption.EncryptionData('123456$#@$^@1ERF', JSON.stringify(response)),
    );
    let path = 'form?k=' + k + '&lang=' + lang1;
    this.router.navigateByUrl(path);
  }
  Remove(response: ParticipationResponseData) {
    let k = '';
    let OfflineResponseData1;
    this.activatedRoute.queryParams.subscribe(async (params) => {
      k = params['k'];
    });
    let encryptedData = this.storage.get('ResponseData_' + k);
    encryptedData = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', encryptedData);
    OfflineResponseData1 = JSON.parse(encryptedData);

    let ind = OfflineResponseData1.indexOf(
      OfflineResponseData1.find(
        (e) => e.ResponseCommanData.ResponseUID == response.ResponseCommanData.ResponseUID,
      ),
    );
    let index = this.OfflineResponseData.indexOf(response);
    OfflineResponseData1.splice(ind, 1);
    this.OfflineResponseData.splice(index, 1);
    this.storage.set(
      'ResponseData_' + k,
      EncryptionAndDecryption.EncryptionData(
        '123456$#@$^@1ERF',
        JSON.stringify(OfflineResponseData1),
      ),
    );

    this.storage.set('ResponseCount_' + k, (this.storage.get('ResponseCount_' + k) || 0) - 1);
    this.ResponseCount = this.storage.get('ResponseCount_' + k) || 0;

    this.incompleteResponse = OfflineResponseData1.filter(
      (e) => e.ResponseCommanData.ResponseStatus == 'INCOMPLETE',
    ).length;
    this.completeResponse = OfflineResponseData1.filter(
      (e) => e.ResponseCommanData.ResponseStatus == 'COMPLETE',
    ).length;

    if (this.isMobile) {
      this.adjustMobileLayout();
    }
  }
  GetUrlData(isLoading: boolean, langID: number): any {
    this.activatedRoute.queryParams.subscribe(async (params) => {
      let k;
      if (Object.prototype.hasOwnProperty.call(params, 'k')) {
        k = params['k'] || '';
      } else {
        k = params.toString();
      }
      this.surveyKey = k;
      let Uid = '';
      const lang = langID;
      if (isLoading) {
        Uid =
          this.offlineModel.OfflineUid == 0 || this.offlineModel.OfflineUid == undefined
            ? ''
            : '&responseUID=' + this.offlineModel.OfflineUid;
      }
      this.urlParam = 'k=' + k + '&lang=' + lang + Uid;
      this.selectedLang = lang;

      this.surveySearchModel.key = k;
      this.surveySearchModel.lang = lang;
      this.surveySearchModel.responseID = this.offlineModel.OfflineUid.toString();
      this.surveySearchModel.surveyQueryString = this.urlParam;
    });
    return this.urlParam;
  }
  GotIt() {
    let k = '';
    this.activatedRoute.queryParams.subscribe(async (params) => {
      k = params['k'];
    });
    this.storage.set('GotIT_' + k, false);
    this.blnShowGotiT = false;
    
    if (this.isMobile) {
      setTimeout(() => {
        this.adjustMobileLayout();
      }, 10);
    }
  }

  switchTabs(status: string) {
    let k = '';
    this.activatedRoute.queryParams.subscribe(async (params) => {
      k = params['k'];
    });
    let encryptedData = this.storage.get('ResponseData_' + k) || [];

    if (encryptedData.length > 0) {
      encryptedData = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', encryptedData);
      this.OfflineResponseData = JSON.parse(encryptedData);
    }
    if (status == 'Completed') {
      document.querySelector('.Incompleted')?.classList.remove('active');
      document.querySelector('.Completed')?.classList.add('active');
      this.OfflineResponseData = this.OfflineResponseData.filter(
        (e) => e.ResponseCommanData.ResponseStatus == 'COMPLETE',
      );
    } else {
      document.querySelector('.Completed')?.classList.remove('active');
      document.querySelector('.Incompleted')?.classList.add('active');
      this.OfflineResponseData = this.OfflineResponseData.filter(
        (e) => e.ResponseCommanData.ResponseStatus == 'INCOMPLETE',
      );
    }
  }

  offlineScriptGenerator() {
    const head = document.getElementsByTagName('head')[0];

    let node2 = document.createElement('script'); // creates the script tag

    node2.type = 'text/javascript'; // set the script type
    node2.innerText =
      "window.OfflineSurvey = { isOfflineSurvey: 'true', Surveytimeout: 180, Thankyoumessagetimeout: 2000, isOfflineEnable: " +
      this.offlineModel.isOfflineEnable +
      ',OfflineURLID:' +
      this.offlineModel.OfflineURLID +
      ",surveyTitle:'" +
      this.offlineModel.surveyTitle +
      "',corp_mailid:'" +
      this.offlineModel.corp_mailid +
      "',surveyno:'" +
      this.offlineModel.surveyno +
      "', primaryLang:'" +
      this.offlineModel.primaryLang +
      "'} ";
    head.appendChild(node2);
  }

  private adjustMobileLayout(): void {
    const rNumbersCont = document.querySelector('.r-numbers-cont') as HTMLElement;
    const rHeader = document.querySelector('.r-header') as HTMLElement;
    const rTabsCont = document.querySelector('.r-tabs-cont') as HTMLElement;
    
    if (rNumbersCont && rHeader) {
      rNumbersCont.style.marginTop = `${rHeader.offsetHeight + 20}px`;
    }
    
    if (rTabsCont && rHeader) {
      if (this.ResponseCount == 0 && this.completeResponse + this.incompleteResponse == 0) {
        rTabsCont.style.marginTop = `${rHeader.offsetHeight + 20}px`;
      } else {
        rTabsCont.style.marginTop = '30px';
      }
    }
  }

  /**
   * Process languages sequentially - one language at a time
   * @param languageDatas Array of language data to process
   * @param lang Current language parameter
   */
  private async processLanguagesSequentially(languageDatas: any[], lang: string): Promise<void> {
    for (const languageData of languageDatas) {
      await this.processSingleLanguage(languageData, lang);
    }
  }

  /**
   * Process a single language - get survey properties and survey data sequentially
   * @param languageData Language data to process
   * @param lang Current language parameter
   */
  private async processSingleLanguage(languageData: any, lang: string): Promise<void> {
    const head = document.getElementsByTagName('head')[0];
    this.GetUrlData(true, languageData.LangID);
    
    try {
      // Step 1: Get Survey Properties
      const propResult = await this.getSurveyProperties();
      
      // Step 2: Process survey properties and set up UI
      await this.processSurveyProperties(propResult, head);
      
      // Step 3: Get Survey Data
      const surveyDataResult = await this.getSurveyData();
      
      // Step 4: Process survey data and store in localStorage
      await this.processSurveyData(surveyDataResult, propResult, languageData, lang);
      
    } catch (error) {
      this.errorsHandlerService.handleError(error);
      if (error.name == 'HttpErrorResponse') {
        window.location.replace('../survey/sd?err=1&ng=1&cn=' + 101);
      }
    }
  }

  /**
   * Get survey properties from API
   */
  private async getSurveyProperties(): Promise<any> {
    const Propurl = "GetSurveyProperties?k=" + this.surveyKey;
    return new Promise((resolve, reject) => {
      this.service
        .GetDataPropAll(
          Propurl,
          JSON.stringify(
            EncryptionAndDecryption.EncryptionData(
              '123456$#@$^@1ERF',
              JSON.stringify(this.surveySearchModel),
            ),
          ),
        )
        .subscribe(
          async (result) => {
            resolve(await result);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  /**
   * Process survey properties and set up UI elements
   */
  private async processSurveyProperties(propResult: any, head: HTMLHeadElement): Promise<void> {
    let arrData = EncryptionAndDecryption.DecryptionData(
      '123456$#@$^@1ERF',
      await propResult,
    );
    arrData = JSON.parse(arrData);
    this.surveyProperties = await arrData.SurveyProperties;
    this.commonSetting = await this.surveyProperties.commonSetting;

    // Set up favicon
    const link = document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = this.surveyProperties.PoweredByLogotxt;
    head.appendChild(link);

    // Set up CSS
    const css = this.surveyProperties.strSurveyCSS;
    this.surveyProperties.Screen_Resolution = this.getResolution();
    if (this.surveyProperties.isErrorRedirect) {
      window.location.replace(this.surveyProperties.RedirectURL);
    }

    const style = document.createElement('style');
    style.appendChild(document.createTextNode(css));
    head.appendChild(style);

    this.surveySearchModel.surveyProperties = this.surveyProperties;
    this.surveySearchModel.Tick = this.commonSetting.strTick;
  }

  /**
   * Get survey data from API
   */
  private async getSurveyData(): Promise<any> {
    const url = "GetSurveyData?k=" + this.surveyKey;
    return new Promise((resolve, reject) => {
      this.service
        .postDataUsingPromise(
          url,
          JSON.stringify(
            EncryptionAndDecryption.EncryptionData(
              '123456$#@$^@1ERF',
              JSON.stringify(this.surveySearchModel),
            ),
          ),
        )
        .then(
          async (result) => {
            resolve(await result);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  /**
   * Process survey data and store in localStorage
   */
  private async processSurveyData(
    surveyDataResult: any, 
    propResult: any, 
    languageData: any, 
    lang: string
  ): Promise<void> {
    let arrData = EncryptionAndDecryption.DecryptionData(
      '123456$#@$^@1ERF',
      await surveyDataResult,
    );

    arrData = JSON.parse(arrData);
    this.surveyData = await arrData.SurveyData;
    this.surveySpecificData = await arrData.SurveySpecificData;
    
    // Store in localStorage
    localStorage.setItem(
      'SurveyProperties_' +
        this.surveySearchModel.key +
        '_' +
        languageData.LangID,
      JSON.stringify(await propResult),
    ); 
    localStorage.setItem(
      'SurveyData_' +
        this.surveySearchModel.key +
        '_' +
        languageData.LangID,
      JSON.stringify(await surveyDataResult),
    ); 
    localStorage.setItem(
      'SurveyresponseUID_' + this.surveySearchModel.key,
      this.offlineModel.OfflineUid.toString(),
    );
    localStorage.setItem(
      'SurveyTick_' + this.surveySearchModel.key,
      this.surveyProperties.commonSetting.strTick,
    );
    
    // Handle OfflineSurveyKey
    let OfflineSurveyKey = localStorage.getItem('OfflineSurveyKey');
    if (!OfflineSurveyKey) {
      localStorage.setItem(
        'OfflineSurveyKey',
        '' +
          this.surveySearchModel.key +
          '_' +
          languageData.LangID +
          '_' +
          this.offlineModel.offlineModeURL,
      );
    } else {
      let n = OfflineSurveyKey.search(
        '' +
          this.surveySearchModel.key +
          '_' +
          languageData.LangID +
          '_' +
          this.offlineModel.offlineModeURL,
      );
      if (n == -1) {
        localStorage.setItem(
          'OfflineSurveyKey',
          OfflineSurveyKey +
            ',' +
            this.surveySearchModel.key +
            '_' +
            languageData.LangID +
            '_' +
            this.offlineModel.offlineModeURL,
        );
      }
    }
    
    // Register service worker
    navigator.serviceWorker.register(
      'ServiceWorker.js?k=' +
        this.surveySearchModel.key +
        '&lang=' +
        lang +
        '&OfflineURL=' +
        this.offlineModel.offlineModeURL +
        '&CLFolderName=' +
        this.offlineModel.folderName +
        '&templink=' +
        this.offlineModel.tempLink +
        '&intVOSurveyNo=' +
        this.offlineModel.surveyno +
        '&OfflineSurveyKey=' +
        localStorage.getItem('OfflineSurveyKey'),
    );
  }

  hideAlert(obj: HTMLElement) {
    const activeElement = obj.closest('.active') as HTMLElement;
    if (activeElement) {
      let startPos = 0;
      const endPos = -1000;
      const duration = 700;
      const startTime = performance.now();

      const animateRight = (currentTime: number) => {
        const elapsedTime = currentTime - startTime;
        if (elapsedTime < duration) {
          const position = startPos + ((endPos - startPos) * (elapsedTime / duration));
          activeElement.style.right = `${position}px`;
          requestAnimationFrame(animateRight);
        } else {
          activeElement.style.right = `${endPos}px`;
          activeElement.classList.remove('active');
        }
      };

      requestAnimationFrame(animateRight);
    }
  }

  scrollResponse() {
    const windowScroll = window.scrollY || document.documentElement.scrollTop;
    let headerHt = 142;
    let headerPad = 55;
    let headerMargin = 30;
    let headerTop = 40;
    let ftSize = 24;
    let mgTop = 25;
    let imgWt = 250;
    let imgHt = 180;
    let imgBottom = 38;
    let imgOpacity = 1;
    let imgMargin = 40;
    let numBtnHt = 59;
    let numberBtnMg = 25;
    let imgBottomReduce = 0;
    let numBtnHtReduce = 0;
    let imgMarginReduce = 0;


    let headerPadReduce = 0.29069;
    let headerMarginReduce = 0.34883;
    let headerTopReduce = 0.27906;
    let ftReduce = 0.12402;
    let mgReduce = 0.20025;
    let imgWtReduce = 2.90696;
    let imgHtReduce = 0;

    if (windowScroll > 60) {
      imgOpacity = 0;
    }

    if (windowScroll * 0.7 <= 86) {
      headerHt -= windowScroll * 0.7;
      headerPad -= headerPadReduce * windowScroll * 0.7;
      headerMargin -= headerMarginReduce * windowScroll * 0.7;
      headerTop -= headerTopReduce * windowScroll * 0.7;
      ftSize -= ftReduce * windowScroll * 0.7;
      mgTop -= mgReduce * windowScroll * 0.7;
      imgWt -= imgWtReduce * windowScroll * 0.7;
      imgHt -= imgHtReduce * windowScroll * 0.7;
      imgBottom -= imgBottomReduce * windowScroll * 1.5;
      imgMargin -= imgMarginReduce * windowScroll * 0.7;
    } else {
      headerHt = 56;
      ftSize = 16;
      mgTop = 6;
      imgHt = 0;
      imgWt = 0;
      imgBottom = 0;
      imgOpacity = 0;
      imgMargin = 0;
      headerPad = 30;
      headerMargin = 0;
      headerTop = 16;

      if (windowScroll * 0.7 <= 157) {
        numBtnHt -= numBtnHtReduce * (windowScroll * 0.7 - 86);
        numberBtnMg += numBtnHtReduce * (windowScroll * 0.7 - 86);
      } else {
        numBtnHt = 0;
        numberBtnMg = 84;
      }
    }

    let responseTop: number = 0;
    let responseBody: HTMLElement | null = null;
    
    if (document.querySelector('.r-response-body:not([style*="display: none"])')) {
      responseBody = document.querySelector('.r-response-body:not([style*="display: none"])') as HTMLElement;
      responseTop = responseBody.getBoundingClientRect().top + window.scrollY;
    } else if (document.querySelector('.r-empty-box:not([style*="display: none"])')) {
      responseBody = document.querySelector('.r-empty-box:not([style*="display: none"])') as HTMLElement;
      responseTop = responseBody.getBoundingClientRect().top + window.scrollY;
    }

    const rTabsCont = document.querySelector('.r-tabs-cont') as HTMLElement;
    
    if (responseTop && responseBody && rTabsCont) {
      if (responseTop + 20 - windowScroll <= 155) {
        rTabsCont.classList.add('fixed-tabs');
        responseBody.style.marginTop = '83px';
      } else {
        rTabsCont.classList.remove('fixed-tabs');
        responseBody.style.marginTop = '0px';
      }
    }

    const rHeader = document.querySelector('.r-header') as HTMLElement;
    const rHeaderBigText = document.querySelector('.r-header-big-text') as HTMLElement;
    const rHeaderImg = document.querySelector('.r-header-img') as HTMLElement;
    const rNumbersCont = document.querySelector('.r-numbers-cont') as HTMLElement;
    
    if (rHeader) {
      rHeader.style.height = `${headerHt}px`;
      rHeader.style.paddingLeft = `${headerPad}px`;
      rHeader.style.paddingRight = `${headerPad}px`;
      rHeader.style.marginTop = `${headerMargin}px`;
      rHeader.style.top = `${headerTop}px`;
    }
    
    if (rHeaderBigText) {
      rHeaderBigText.style.fontSize = `${ftSize}px`;
      rHeaderBigText.style.marginTop = `${mgTop}px`;
    }
    
    if (rHeaderImg) {
      rHeaderImg.style.width = `${imgWt}px`;
      rHeaderImg.style.height = `${imgHt}px`;
      rHeaderImg.style.bottom = `${imgBottom}px`;
      rHeaderImg.style.opacity = imgOpacity.toString();
      rHeaderImg.style.marginRight = `${imgMargin}px`;
    }
    
    if (rNumbersCont) {
      rNumbersCont.style.height = `${numBtnHt}px`;
      rNumbersCont.style.marginTop = `${numberBtnMg}px`;
    }
  }
}
